import React from "react";

const MSG = "Livraison à domicile en Guadeloupe  •  Ventes privées à la maison  •  Commande WhatsApp disponible  •  Livraison suivie au meilleur tarif";

export const AnnouncementBar = () => {
  return (
    <div className="bg-noir text-white overflow-hidden py-2 border-b border-dore/20" data-testid="announcement-bar">
      <div className="flex whitespace-nowrap animate-marquee will-change-transform">
        {[0, 1].map((k) => (
          <span key={k} className="mx-8 text-[11px] sm:text-xs uppercase tracking-[0.25em] text-white/90 font-light">
            {MSG}
          </span>
        ))}
      </div>
    </div>
  );
};

export default AnnouncementBar;
